import { useState } from "react";
import ExectiveSummaryDesktop from "../components/desktop/executive-summary/ExecutiveSummaryDesktop";
import FieldForceDesktop from "../components/desktop/executive-summary/field-force/FieldForceDesktop";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Stack, Tab, Typography } from "@mui/material";
import Header from "../components/Header";

const ExecutiveSummary = () => {
  const [value, setValue] = useState<string>("performance_summary");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <Stack p={2}>
      <TabContext value={value}>
        <Header title="Executive Summary" />
        <TabList onChange={handleChange}>
          <Tab label={"Performance Summary"} value={"performance_summary"} />
          <Tab label={"Field Effort"} value={"field_effort"} />
        </TabList>
        <TabPanel sx={{ p: 0 }} value={"performance_summary"}>
          <ExectiveSummaryDesktop />
        </TabPanel>
        <TabPanel sx={{ p: 0 }} value={"field_effort"}>
          <FieldForceDesktop />
        </TabPanel>
      </TabContext>
    </Stack>
  );
};

export default ExecutiveSummary;
